import { FC } from 'react';
import { Pagination } from 'antd';
import TableAtom from 'components/atoms/TableAtom';
import { EditSensorModal } from 'components/molecules/EditSensorModal';
import { DEFAULT_PAGE_SIZE } from 'components/organisms/AlfredTable';
import { TABLE_PAGE_SIZE_DEFAULT_OPTIONS } from 'constants/table';
import TableFilter from 'components/organisms/TableFilter';
import DefaultButton from 'components/atoms/Button/DefaultButton';
import MultipleTagEditorModal from 'components/organisms/MultipleTagEditorModal';
import { useSensorOptionList } from './resources/useSensorOptionList';
import { CustomSensorModel } from './resources/models';
import './styles.scss';

interface OptionListProps {
  assetId: string;
}

const OptionList: FC<OptionListProps> = ({ assetId }) => {
  const {
    data,
    columns,
    selectedSensorNumberText,
    editSensorOptions,
    assignTagsButtonText,
    maxSizeResponsiveScreen,
    currentPage,
    currentSize,
    totalPages,
    filters,
    rowSelectionConfig,
    multipleTagEditorModalOptions,
    deselectAllSensorsButtonText,
    onChangePage,
    onApplyFilters,
    onOpenMultipleTagsEditorModal,
    onDeselectAllSensors,
    isUserSuperAdmin,
    loading,
    isDeselectButtonDisabled,
  } = useSensorOptionList(true);

  return (
    <>
      <div className={'OptionList__buttons'}>
        <div className={'OptionList__buttons--right'}>
          {isUserSuperAdmin && (
            <DefaultButton
              title={assignTagsButtonText}
              onClick={onOpenMultipleTagsEditorModal}
            />
          )}
          <TableFilter
            loading={loading}
            initialFilters={filters}
            onApply={onApplyFilters}
            isMultiple
          />
        </div>
        {isUserSuperAdmin && (
          <div className={'OptionList__buttons--left'}>
            {selectedSensorNumberText}
            <div>
              <DefaultButton
                title={deselectAllSensorsButtonText}
                disabled={isDeselectButtonDisabled}
                onClick={onDeselectAllSensors}
              />
            </div>
          </div>
        )}
      </div>
      <TableAtom<CustomSensorModel>
        key={'OptionList'}
        loading={loading}
        dataSource={data}
        columns={columns}
        scroll={{ x: maxSizeResponsiveScreen }}
        rowKey={'id'}
        pagination={false}
        rowSelection={isUserSuperAdmin ? rowSelectionConfig : undefined}
      />
      <Pagination
        className={'OptionList__pagination'}
        size={'small'}
        showSizeChanger={true}
        defaultPageSize={DEFAULT_PAGE_SIZE}
        pageSizeOptions={TABLE_PAGE_SIZE_DEFAULT_OPTIONS}
        current={currentPage}
        total={currentSize * totalPages}
        pageSize={currentSize}
        onChange={onChangePage}
      />
      {!!editSensorOptions.sensor && (
        <EditSensorModal
          options={editSensorOptions}
          sensor={editSensorOptions.sensor}
          open={editSensorOptions.visible}
          onCancel={editSensorOptions.onCloseEditSensorModal}
        />
      )}
      <MultipleTagEditorModal
        modalOptions={multipleTagEditorModalOptions}
        open={multipleTagEditorModalOptions.multipleTagEditorModalVisible}
        onCancel={multipleTagEditorModalOptions.onCloseMultipleTagEditorModal}
      />
    </>
  );
};

export default OptionList;
